var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2894 105.645C39.6519 97.7429 35.449 84.4099 33.8906 68.712M45.2894 4.58203C41.4577 9.82995 38.286 17.782 36.1594 27.3062M64.7227 105.645C70.3235 97.7979 74.5081 84.5887 76.0894 69.0237M64.7227 4.58203C69.5215 11.1545 73.2844 21.9712 75.2552 34.7954",
    stroke: "#464646",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39844 30.9367C46.0834 23.9196 65.943 23.883 100.607 30.9367M100.607 79.0617C63.9264 86.0834 44.0668 86.1155 9.39844 79.0617M4.58594 55.0221H30.4359C30.75 55.0248 31.0582 54.9378 31.3245 54.7714C31.5908 54.605 31.8041 54.366 31.9393 54.0826L39.8089 38.1096C39.9557 37.8138 40.1857 37.5674 40.4707 37.4004C40.7557 37.2335 41.0832 37.1535 41.413 37.1701C41.7435 37.1866 42.0613 37.302 42.3253 37.5014C42.5893 37.7009 42.7872 37.9751 42.8934 38.2884L53.5772 68.103C53.6875 68.4258 53.8926 68.7078 54.1657 68.9122C54.4388 69.1166 54.7672 69.234 55.108 69.2488C55.4503 69.2634 55.7887 69.1711 56.0762 68.9846C56.3636 68.7982 56.5859 68.5269 56.7122 68.2084L67.0247 44.6867C67.1538 44.3952 67.3624 44.1459 67.6267 43.9676C67.891 43.7892 68.2002 43.689 68.5189 43.6784C68.8391 43.6686 69.1552 43.7522 69.4286 43.9191C69.7021 44.0859 69.9211 44.3288 70.0589 44.618L74.7201 54.0826C74.86 54.3633 75.075 54.5998 75.3412 54.7656C75.6074 54.9315 75.9144 55.0203 76.228 55.0221H105.419",
    stroke: "#464646",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.363 43.8717C100.275 20.7442 79.6639 3.4375 55.0055 3.4375C30.3472 3.4375 9.73594 20.7442 4.64844 43.8717M105.363 66.1283C100.275 89.2558 79.6639 106.563 55.0055 106.563C30.3472 106.563 9.73594 89.2558 4.64844 66.1283",
    stroke: "#464646",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout33);
export default __webpack_public_path__ + "static/media/about3-3.d366f661d1313893be24f136ddfde8d8.svg";
export { ForwardRef as ReactComponent };